import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CategoriesResourceService } from './categoriesResource.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-resource-controls',
  templateUrl: './categoriesResource.component.html',
  styles: []
})
export class CategoriesResourceComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  resources: any;
  showImages: boolean;
  showDocs: boolean;
  showVedio: boolean;

  constructor(private resourceService: CategoriesResourceService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    console.log('route_params_id', this.route.params['value'].id);
    this.resources = this.resourceService.resources
    console.log('resources_list', this.resources);
  }

  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }

  getDocs(mediaUrl) {
    const types = new Map([["jpg", "img"], ["png", "img"], ["jpeg", "img"], ["gif", "img"], ["mp4", "video"], ["3gp", "video"]])
    const url = new URL(mediaUrl)
    const extension = url.pathname.split(".")[1];
    if (['jpg', 'jpeg', 'gif', 'png'].includes(extension)) {
      this.showDocs = false;
      this.showVedio = false;
      this.showImages = true;
      return 'Image';
    } else if (['3gp', 'mp4'].includes(extension)) {
      this.showImages = false;
      this.showDocs = false;
      this.showVedio = true;
      return 'Video';
    } else {
      this.showImages = false;
      this.showVedio = false;
      this.showDocs = true;
      return 'Docs';
    }
  }

}
